import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { ConfirmPopup } from '~/commonComponents';
import AnimatedCheckCircle from '~/components/shared/AnimatedCheckCircle';

const SuccessIconComponent = () => <AnimatedCheckCircle />;

interface IHireCandidateSuccessPopupProps {
  onClose: () => void;
}

export const HireCandidateSuccessPopup = ({
  onClose,
}: IHireCandidateSuccessPopupProps) => (
  <ConfirmPopup
    Icon={SuccessIconComponent}
    title="Congratulations on Your Hire!"
    titleStyle={{ marginTop: 21, marginBottom: 16 }}
    description={
      <Typography as="span" color={colors.neutral[500]}>
        The candidate's status has been updated and moved to
        <br />
        the Hired tab. We're glad GoTu helped you find the
        <br />
        right professional for your team.
      </Typography>
    }
    descriptionStyle={{ width: '100%', marginBottom: 38 }}
    modalStyle={{ width: 560 }}
    rightButtonText="Done"
    rightButtonAction={onClose}
  />
);
